import { useState } from 'react';
import { Cable, Cpu, AlertTriangle } from 'lucide-react';

import LlmChannelsTab from './LlmChannelsTab';
import LlmModelsTab from './LlmModelsTab';
import LlmFailureLogsTab from './LlmFailureLogsTab';

type SubTab = 'channels' | 'models' | 'failure-logs';

const SUB_TABS: Array<{ key: SubTab; label: string; icon: typeof Cable }> = [
  { key: 'channels', label: '渠道', icon: Cable },
  { key: 'models', label: '模型', icon: Cpu },
  { key: 'failure-logs', label: '失败日志', icon: AlertTriangle },
];

export default function LlmPlatformTab() {
  const [active, setActive] = useState<SubTab>('models');

  return (
    <div className="max-w-6xl">
      <div className="bg-white rounded-2xl shadow-lg border border-light-border overflow-hidden">
        <div className="px-6 py-4 border-b border-light-border">
          <h3 className="text-lg font-semibold text-light-text">LLM 平台</h3>
          <p className="text-sm text-light-muted mt-1">
            管理 LLM 渠道（apiKey）与模型实例。各业务功能（拆分镜配置、提示词优化等）在自己的页面下拉选择此处建好的模型即可。
          </p>
        </div>

        <div className="px-6 border-b border-light-border flex items-center gap-1 overflow-x-auto">
          {SUB_TABS.map((tab) => {
            const Icon = tab.icon;
            const activeFlag = active === tab.key;
            return (
              <button
                key={tab.key}
                onClick={() => setActive(tab.key)}
                className={`flex items-center gap-2 px-4 py-3 text-sm font-medium border-b-2 transition-colors whitespace-nowrap ${
                  activeFlag
                    ? 'border-accent-blue text-accent-blue'
                    : 'border-transparent text-light-muted hover:text-light-text'
                }`}
              >
                <Icon className="w-4 h-4" />
                {tab.label}
              </button>
            );
          })}
        </div>

        <div className="p-6">
          {active === 'channels' && <LlmChannelsTab />}
          {active === 'models' && <LlmModelsTab />}
          {active === 'failure-logs' && <LlmFailureLogsTab />}
        </div>
      </div>
    </div>
  );
}
